import React from "react";
import styled from "styled-components";
import theme from "Styles/theme";

interface ZoomController {
	className?: string;
	onChange: any;
	value: number;
}
const Wrapper = styled.div`
	width: 100%;
	${(props) => props.theme.layout.center_flex};
`;
const Controller = styled.input`
	width: 100%;
	-webkit-appearance: none;
	background: transparent;

	&[type="range"]:focus {
		outline: none;
	}

	&[type="range"]::-webkit-slider-thumb {
		-webkit-appearance: none;
		background: ${(props) => props.theme.color.bg};
		cursor: pointer;
		border: 1px solid white;
		height: ${(props) => `${props.theme.size.zoom.controller}px`};
		width: ${(props) => `${props.theme.size.zoom.controller}px`};
		border-radius: 100%;
		transform: translateY(-50%) translateY(10px);
	}

	&[type="range"]::-webkit-slider-runnable-track {
		cursor: pointer;
		width: 100%;
		height: 20px;
		background: transparent;
	}
`;
const ZoomController: React.FC<ZoomController> = ({ className, onChange, value }) => {
	return (
		<Wrapper className={className}>
			<Controller type="range" value={value} min={theme.size.zoom.min} max={theme.size.zoom.max} onChange={onChange} step="0.1" />
		</Wrapper>
	);
};

export default ZoomController;
